import React, { useEffect, useState, useRef } from 'react';
import { Card, Row, Col, Modal, Button, Form, FormLabel, InputGroup, FormControl, OverlayTrigger, Tooltip } from 'react-bootstrap';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import { getCoreRowModel } from '@tanstack/react-table';
import { getExpandedRowModel } from '@tanstack/react-table';
import { useReactTable } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';
import { getPaginationRowModel } from '@tanstack/react-table';
import { getFilteredRowModel } from '@tanstack/react-table';
import { GoogleMapsProvider } from '../../../../../providers/GoogleMapsProvider';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaFileExport, FaMapMarkerAlt } from 'react-icons/fa';
//import GoogleMapRoutes from "../../../../../components/common/GoogleMap";
import { segundosATiempo } from '../../../../../helpers/utils';
import AdvanceTableFooter from '../../../../../components/common/advance-table/AdvanceTableFooter';
import useAdvanceTable from '../../../../../hooks/useAdvanceTable';
import GoogleMapSelector, { obtenerInfoView, obtenerInfoViewTop } from '../../../../../components/common/google-maps-selector/GoogleMapSelector';
import IconButton from '../../../../../components/common/IconButton';
import iconoPng from '../../../../../assets/img/icons/export.png';
import { obtenerIconoTipoEstadia, obtenerIconoEvento } from '../../../../../components/common/google-maps-selector/IconosTabla';
import Flex from '../../../../../components/common/Flex';
import { marker } from 'leaflet';
import classNames from 'classnames';
import { generateExcelReport } from '../../../../../helpers/createExcelReport';
import { geocodeService } from '../../../../../services/geocodeService';
// Activamos el soporte para formatos personalizados
dayjs.extend(customParseFormat);
dayjs.locale('es');

// const formatFecha = (fechaStr) => {
//     if (!fechaStr || typeof fechaStr !== 'string') return ' ';

//     try {
//         let fechaFormateada = dayjs(fechaStr, 'YYYY/MM/DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
//         return fechaFormateada; //dayjs(fechaStr, 'YYYY/MM/DD/ HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
//     } catch (error) {
//         console.error('Error al formatear la fecha:', error);
//         return 'N/A';
//     }
// };

const formatFecha = (fechaStr) => {
    if (!fechaStr || typeof fechaStr !== 'string') return ' ';

    try {
        // ✅ dayjs puede parsear automáticamente formatos ISO estándar
        let fechaFormateada = dayjs(fechaStr).format('DD/MM/YYYY HH:mm:ss');
        return fechaFormateada;
    } catch (error) {
        console.error('Error al formatear la fecha:', error);
        return 'N/A';
    }
};

const MasterTableEstadias = ({ data = [], geocercas = [], referencias, clientes, perPage = 100, title, isGroup, searchValue = '', onSearch }) => {
    const [safeTableData, editSafeTableData] = useState([]);
    const [infoView, setInfoView] = useState(null);
    // Estado para manejar el modal del mapa
    const [globalFilter, setGlobalFilter] = useState(searchValue);
    const [inputValue, setInputValue] = useState(searchValue);
    const debounceTimeout = useRef(null);
    const [globalTableFilter, setGlobalTableFilter] = useState('');
    const [expanded, setExpanded] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState({ lat: null, lng: null });
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [markers, setMarkers] = useState([]);
    const [geocercasFiltradas, setGeocercasFiltradas] = useState([]);

    const style1Lines = {
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    const [pagination, setPagination] = useState({
        pageIndex: 0, //initial page index
        pageSize: perPage, //default page size
    });
    // Dedupe persistente entre re-renders: keys que ya encolamos para evitar reencolar
    const queuedGeocodeKeysRef = useRef(new Set());
    const obtenerIcono = (tipoAlerta) => {
        var icono = obtenerIconoEvento(tipoAlerta);
        const src = icono?.props?.src;
        return icono;
    };

    const estadiaStr = (item) => {
        const totalTiempo = item.children.reduce((suma, it) => suma + it.tiempo_segundos, 0)
        const duracionEstadia = segundosATiempo(totalTiempo)
        return `Estadías: ${item.children.length}, Duración de estadías: ${duracionEstadia} hr(s)`;
    };
    // ✅ Función PURA: solo calcula y retorna. El state `geocercasFiltradas` se setea
    // cuando se abre el mapa (handleShowMap), no en el data mapping (antes se llamaba
    // por cada item, generando state churn proporcional al número de filas).
    const obtenerArregloGeocercas = (item) => {
        if (!item || !Array.isArray(geocercas)) {
            return [];
        }
        const arregloGeocercas = geocercas.map(g => {
            const sumaTotales = g.puntos.reduce(
                (acc, punto) => {
                    acc.lat += punto.latitud;
                    acc.lng += punto.longitud;
                    return acc;
                },
                { lat: 0, lng: 0 }
            );
            const total = g.puntos.length;
            return ({
                ...g,
                lat: total > 0 ? sumaTotales.lat / total : 0,
                lng: total > 0 ? sumaTotales.lng / total : 0
            })
        });

        if (item.tipo === 'geocercas') {
            const nombreGeocercas = (item.punto_inicio || '').toLowerCase().split(',');
            return arregloGeocercas.filter(g =>
                nombreGeocercas.some(n => g.nombre.toLowerCase().includes(n.trim()))
            );
        }
        return arregloGeocercas;
    };
    const obtenerArregloClientes = (item) => {
        /*CARGA DE CLIENTES*/
        const nombreClientes = (item.punto_inicio || '').toLowerCase().split(',');
        return (clientes.filter(g => nombreClientes.includes(g.nombre.toLowerCase())));
    };
    const obtenerArregloReferencias = (item) => {
        /*CARGA DE REFERENCIAS*/
        const nombreReferencias = (item.punto_inicio || '').toLowerCase().split(',');
        return (referencias.filter(g => nombreReferencias.includes(g.nombre.toLowerCase())));
    };
    useEffect(() => {
        const filterItemAndChildren = (item, filter) => {
            // Filtra los hijos recursivamente
            let filteredChildren = [];
            if (Array.isArray(item.children)) {
                filteredChildren = item.children
                    .map(child => filterItemAndChildren(child, filter))
                    .filter(Boolean);
            }
            const tipoStr = item.tipo ? item.tipo.charAt(0).toUpperCase() + item.tipo.slice(1).toLowerCase() : '';
            // Checa si el item actual pasa el filtro
            const matches = (
                (item.evento && item.evento.toLowerCase().includes(filter)) ||
                (item.no_economico && item.no_economico.toLowerCase().includes(filter)) ||
                (item.chofer && item.chofer.toLowerCase().includes(filter)) ||
                (item.punto_fin && item.punto_fin.toLowerCase().includes(filter)) ||
                (item.fecha_inicio && item.fecha_inicio.toLowerCase().includes(filter)) ||
                (item.fecha_fin && item.fecha_fin.toLowerCase().includes(filter)) ||
                (item.tiempo && item.tiempo.toLowerCase().includes(filter)) ||
                (item.estadiaStr && item.estadiaStr.toLowerCase().includes(filter)) ||
                (tipoStr && tipoStr.toLowerCase().includes(filter))
            );

            // Si el padre coincide, muestra el padre y todos los hijos originales (sin filtrar)
            if (matches) {
                return {
                    ...item,
                    children: Array.isArray(item.children) ? item.children : []
                };
            }

            // Si algún hijo coincide, muestra el padre solo con los hijos filtrados
            if (filteredChildren.length > 0) {
                return {
                    ...item,
                    children: filteredChildren
                };
            }

            // Si ni el padre ni los hijos coinciden, descarta el nodo
            return null;
        };

        let dataMapped = (Array.isArray(data) ? data : []).map((item, index) => {
            let newItem = {
                ...item,
                ismaster: isGroup && index === 0,
                no_economico: item.no_economico || '',
                alias: item.alias || '',
                chofer: item.chofer || '',
                evento: item.evento || '',
                tipo: item.tipo || '',
                tiempo: item.tiempo || '',
                tiempo_segundos: item.tiempo_segundos || 0,
                latitud: parseFloat(item.latitud) || 0,
                longitud: parseFloat(item.longitud) || 0,
                estadiaStr: estadiaStr(item) || '',
                geocercasFiltradas: obtenerArregloGeocercas(item) || [],
                clientesFiltrados: obtenerArregloClientes(item) || [],
                referenciasFiltradas: obtenerArregloReferencias(item) || [],
                children: item.children.map(w => {
                    const direccionOriginal = w.direccion || w.Direccion || item.direccion || item.Direccion || '';
                    // Solo si la dirección original falta, intentamos completarla con el cache existente.
                    const direccionResuelta = geocodeService.isAddressMissing(direccionOriginal)
                        ? (geocodeService.getCachedAddress(w.latitud, w.longitud) || direccionOriginal)
                        : direccionOriginal;
                    return ({
                        ...w,
                        fecha_inicio: formatFecha(w.fecha_inicio),
                        fecha_fin: formatFecha(w.fecha_fin),
                        direccion: direccionResuelta,
                        __rowKey: `${w.uid_vehiculo || item.uid_vehiculo || ''}::${w.fecha_inicio || ''}::${w.fecha_fin || ''}::${w.latitud || ''}::${w.longitud || ''}`
                    })
                })
            };
            return newItem;
        });

        if (globalFilter && globalFilter.trim() !== "") {
            const filter = globalFilter.trim().toLowerCase();
            dataMapped = dataMapped
                .map(item => filterItemAndChildren(item, filter))
                .filter(Boolean);
        }

        editSafeTableData(dataMapped);

        // ✅ Geocodificación inversa: solo si está habilitada por configuración (.env)
        // y solo para puntos cuya dirección realmente falte (no en cache, no resuelta).
        // Dedupe persistente vía queuedGeocodeKeysRef para no reencolar en cada re-render.
        if (!geocodeService.isReverseGeocodingEnabled()) {
            return;
        }

        const pending = [];
        dataMapped.forEach(group => {
            (Array.isArray(group.children) ? group.children : []).forEach(child => {
                const addr = child?.direccion || child?.Direccion || '';
                if (!geocodeService.isAddressMissing(addr)) return;

                const lat = child?.latitud;
                const lng = child?.longitud;
                if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return;

                // Si ya fue encolado/resuelto antes en esta sesión, no reencolar
                if (queuedGeocodeKeysRef.current.has(child.__rowKey)) return;
                queuedGeocodeKeysRef.current.add(child.__rowKey);

                pending.push({ key: child.__rowKey, lat, lng });
            });
        });

        if (pending.length > 0) {
            pending.forEach(({ key, lat, lng }) => {
                geocodeService
                    .getReverseGeocodeAsync(lat, lng, { timeoutMs: 4000, concurrency: 6 })
                    .then(resp => {
                        const formattedAddress = resp?.formattedAddress;
                        if (!formattedAddress) return;

                        editSafeTableData(prev => {
                            if (!Array.isArray(prev) || prev.length === 0) return prev;

                            let anyChanged = false;
                            const next = prev.map(group => {
                                if (!Array.isArray(group.children) || group.children.length === 0) return group;

                                let groupChanged = false;
                                const nextChildren = group.children.map(child => {
                                    if (child.__rowKey !== key) return child;

                                    const currentAddr = child?.direccion || child?.Direccion || '';
                                    if (!geocodeService.isAddressMissing(currentAddr)) return child;

                                    groupChanged = true;
                                    anyChanged = true;
                                    return { ...child, direccion: formattedAddress };
                                });

                                return groupChanged ? { ...group, children: nextChildren } : group;
                            });

                            return anyChanged ? next : prev;
                        });
                    })
                    .catch(() => null);
            });
        }
    }, [data, globalFilter]);

    const obtenerMarcadorAlertas = (alerta, isMarkerColumn = false) => {
        var index = 0;

        //if (alerta.alerta_real?.includes("Movimiento")) return null;
        index += 1;
        //let arregloFecha = (alerta.fecha || '').split(' ');
        if (isMarkerColumn === false) {
            setInfoView(obtenerInfoViewTop({
                markerId: index,
                titulo: ((alerta.no_economico || '') + ' / ' + alerta.alias) || '',
                colorFondoTitulo: alerta.color_vehiculo || 'black',
                colorTextoTitulo: 'text-white',
                velocidad: alerta.velocidad || '',
                alerta: alerta.alerta_real || '',
                fecha: alerta.fecha,//dayjs(alerta.fecha).format('DD/MM/YYYY HH:mm:ss') || '',
                ruta: alerta.distancia ? (alerta.distancia).toFixed(3) : 'N/A',
                chofer: alerta.chofer || 'N/A'
            }))
        }
        return isMarkerColumn === false ? {
            lat: parseFloat(alerta.latitud),
            lng: parseFloat(alerta.longitud),
            icon: obtenerIcono(alerta.tipo_real, alerta.tipo_alerta),
            radio: alerta.radio,
            title: alerta.alerta_real,
            /*infoView: obtenerInfoView({
                markerId: index,
                titulo: ((alerta.no_economico || '') + ' / ' + alerta.alias),
                colorFondoTitulo: alerta.color || 'black',
                colorTextoTitulo: 'text-white',
                velocidad: alerta.velocidad || '',
                alerta: alerta.alerta_real || '',
                fecha: arregloFecha.length > 0 ? arregloFecha[0] : '',
                hora: arregloFecha.length > 0 ? arregloFecha[1] : '',
                ruta: (alerta.distancia ? alerta.distancia.toFixed(3) : 'N/A'),
                chofer: alerta.chofer || 'N/A'
            }),*/
        } :
            {
                lat: parseFloat(alerta.latitud),
                lng: parseFloat(alerta.longitud),
                icon: obtenerIcono(alerta.tipo_real, alerta.tipo_alerta),
                radio: alerta.radio,
                /*infoView: obtenerInfoView({
                    markerId: index,
                    titulo: alerta.alerta_real || '',
                    colorFondoTitulo: '#5f07a3',
                    colorTextoTitulo: 'text-white',
                    ocultarBody: true
                }),*/
            };
    };

    // Función para abrir el modal con la latitud y longitud seleccionadas
    const handleShowMap = (points, rowData) => {
        setSelectedLocation(points[0]);
        setSelectedLocations(points);
        // Setear geocercas del modal según la fila clickeada (antes se hacía en cada item del data map)
        setGeocercasFiltradas(Array.isArray(rowData?.geocercasFiltradas) ? rowData.geocercasFiltradas : []);
        let _markers = [];
        _markers = [
            ...((rowData.clientesFiltrados || []).map(c => {
                let alerta = {
                    latitud: c?.latitud,
                    longitud: c?.longitud,
                    tipo_real: 99990,
                    alerta_real: c.nombre,
                    radio: c?.radio || 0,
                };
                return obtenerMarcadorAlertas(alerta, true);
            }) || []),
            ...((rowData.geocercasFiltradas || []).map(c => {

                let alerta = {
                    latitud: c.lat,
                    longitud: c.lng,
                    tipo_real: 99991,
                    alerta_real: c.nombre
                };
                return obtenerMarcadorAlertas(alerta, true);
            }) || []),
            ...((rowData.referenciasFiltradas || []).map(c => {
                let alerta = {
                    latitud: c?.latitud,
                    longitud: c?.longitud,
                    tipo_real: 99992,
                    alerta_real: c.nombre,
                    radio: c?.radio || 0,
                };
                console.log(alerta);
                return obtenerMarcadorAlertas(alerta, true);
            }) || [])
        ];
        let markerEvent = obtenerMarcadorAlertas({ ...rowData, alerta_real: rowData.alerta_real.toLowerCase() === 'apagado' ? 'Apagado de motor' : rowData.alerta_real, fecha: rowData.fecha_inicio, tipo_real: (rowData.alerta_real.toLowerCase() === 'apagado' && rowData.tipo_real === 1 ? 5 : rowData.tipo_real) });
        console.log(_markers);
        setMarkers([markerEvent, ..._markers]);
        setShowMapModal(true);
    };

    /*useEffect(()=>{

    },[])*/


    // Estructura de columnas 
    const columns = [
        {
            header: ' ',
            cell: ({ row }) => {
                return row.getCanExpand() ?

                    <IconButton
                        variant="falcon-default"
                        size="sm"
                        icon={row.getIsExpanded() ? "chevron-up" : "chevron-down"}
                        transform="shrink-3"
                        onClick={row.getToggleExpandedHandler()}
                    />
                    : '';
            }
        },
        {
            accessorKey: 'chofer', header: 'Chofer',
            cell: ({ row: { original } }) => {
                return <span style={{ ...style1Lines, maxWidth: '100px' }}></span>;
            }
        },
        //{ accessorKey: 'evento', header: 'Evento' },
        {
            accessorKey: 'evento',
            header: 'Evento',
            cell: ({ row: { original } }) => {
                var eventoOriginal = original.evento || '';
                const eventoLowerCase = eventoOriginal.toLowerCase();

                if (eventoLowerCase === 'apagado' || eventoLowerCase.includes('apagado')) {
                    eventoOriginal = 'Apagado de Motor';
                }

                // ✅ Para cualquier otro evento, mostrar el texto original
                return <span style={style1Lines}>{eventoOriginal}</span>;
            }
        },
        {
            accessorKey: 'punto_fin',
            header: 'Marcador',
            cell: ({ row: { original } }) => {

                const dataOriginal = original.punto_fin || '';
                const tipo = original.tipo;
                let tipoStr = tipo.charAt(0).toUpperCase() + tipo.slice(1).toLowerCase();
                return (

                    <div
                        className="text-truncate"
                        style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                        title={dataOriginal}
                    >

                        <div>
                            <strong style={style1Lines} title={dataOriginal}>{dataOriginal}</strong>
                            <span> {tipoStr}</span>
                        </div>

                    </div>
                );



                //return <>{obtenerIconoTipoEstadia(tipo)} {dataOriginal}</>;
            }
        },

        {
            accessorKey: 'fecha_inicio', header: 'Fecha de inicio', cell: ({ row: { original } }) => {

                //Obtiene la fecha original
                const output = original.fecha_inicio;

                //Retorna la fecha con nuevo formato
                return <span className='text-nowrap flex-nowrap' style={{ ...style1Lines }} title={output}>{output}</span>;
            }
        },
        {
            accessorKey: 'fecha_fin', header: 'Fecha de fin', cell: ({ row: { original } }) => {

                //Obtiene la fecha original
                const output = original.fecha_fin;

                //Retorna la fecha con nuevo formato
                return <span className='text-nowrap flex-nowrap' style={{ ...style1Lines }} title={output}>{output}</span>;
            }
        },
        //{ accessorKey: 'punto_inicio', header: 'Punto Inicio' },
        //{ accessorKey: 'punto_fin', header: 'Punto Fin' },
        {
            accessorKey: 'tiempo', header: 'Duración', cell: ({ row: { original } }) => {

                const output = original.tiempo;

                //Retorna la fecha con nuevo formato
                return <span className='text-nowrap flex-nowrap' style={{ ...style1Lines }} title={output}>{output}</span>;
            }
        },

        {
            accessorKey: 'coordenadas',
            header: 'Coordenadas',
            cell: ({ row: { original } }) => {
                if (original.ismaster) return null;
                const lat = parseFloat(original.latitud || 0).toFixed(5);
                const lng = parseFloat(original.longitud || 0).toFixed(5);
                const coords = `${original.latitud}, ${original.longitud}`;
                const [copied, setCopied] = React.useState(false);
                return (
                    <OverlayTrigger placement="top" overlay={<Tooltip>{copied ? 'Copiado!' : 'Clic para copiar'}</Tooltip>}>
                        <span
                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                            onClick={() => {
                                navigator.clipboard.writeText(coords);
                                setCopied(true);
                                setTimeout(() => setCopied(false), 1500);
                            }}
                        >
                            {lat}, {lng}
                        </span>
                    </OverlayTrigger>
                );
            }
        },
        {
            accessorKey: 'mapa',
            header: 'Ubicación',
            cell: ({ row: { original } }) => (
                original.ismaster ? null : (
                    <div className="d-flex align-items-center gap-2">
                        <a
                            href='#!'
                            className=""
                            onClick={() => {
                                handleShowMap(
                                    [
                                        { lat: parseFloat(original.latitud), lng: parseFloat(original.longitud) }
                                    ],
                                    original
                                );
                            }}
                        >
                            <FaMapMarkerAlt className="text-danger" />
                        </a>
                        <span title={original.direccion || ''} style={style1Lines}>
                            {original.direccion || 'Dirección no disponible'}
                        </span>
                    </div>
                )
            )
        },
        { accessorKey: 'tiempo_segundos', header: 'TiempoSegundos' },
    ];


    const table = useReactTable({
        data: safeTableData,
        columns,
        pagination: true,
        perPage,
        sortable: true,
        initialState: {
            columnVisibility: {
                tiempo_segundos: false
            }
        },
        state: {
            //globalFilter,
            pagination,
        },
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSubRows: (row) => row.children,
        getExpandedRowModel: getExpandedRowModel(),
        enableGlobalFilter: true,
        debugTable: false,
        enableColumnFilters: false
    });

    // Manejar el cambio en la búsqueda global
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        debounceTimeout.current = setTimeout(() => {
            setGlobalFilter(value);
            if (onSearch) onSearch(value);
            setPagination(prev => ({ ...prev, pageIndex: 0 }));
        }, 400);
    };

    const Filter = function ({ column, table }) {
        const firstValue = table
            .getPreFilteredRowModel()
            .flatRows[0]?.getValue(column.id)
        const columnFilterValue = column.getFilterValue()

        return typeof firstValue === "number" ? (
            <div className="flex space-x-2">
                <input
                    type="number"
                    value={columnFilterValue?.[0] ?? ""}
                    onChange={e => column.setFilterValue(old => [e.target.value, old?.[1]])}
                    placeholder={`Min`}
                    className="w-24 border shadow rounded"
                />
            </div>
        ) : (
            <input
                type="text"
                value={columnFilterValue ?? ""}
                onChange={e => column.setFilterValue(e.target.value)}
                placeholder={`Search...`}
                className="w-36 border shadow rounded"
            />
        )
    }

    // Descargar Reporte EXCEL 
    const handleExportToExcel = async () => {
        try {
            // ✅ Esperar cualquier geocodificación en vuelo antes de iniciar el export
            await geocodeService.awaitIdle(8000);

            // ✅ Intentar resolver direcciones faltantes antes de exportar (más margen para este flujo)
            await geocodeService.prefetchMissingAddressesFromEstadias(safeTableData, { timeoutMs: 12000, concurrency: 8 });
            await geocodeService.awaitIdle(8000);

            //Columnas del reporte 
            let columns = [
                'Tipo Reporte',
                'No Economico',
                'Alias Vehiculo',
                'Evento',
                'Fecha Inicio',
                'Fecha Fin',
                'Punto Inicio',
                'Punto Fin',
                'Latitud',
                'Longitud',
                'Coordenadas',
                'Ubicación',
                'Tiempo',
            ]

            // Agregar maestro-detalle 

            let dataReport = [];

            for (const grupo of (Array.isArray(safeTableData) ? safeTableData : [])) {

                //Detallado por vehiculo --------------------------------
                let subList = [];

                // Filas de detalles
                for (const detalle of (Array.isArray(grupo?.children) ? grupo.children : [])) {

                    const direccionActual = detalle.direccion || detalle.Direccion || '';
                    const direccionCache = geocodeService.getCachedAddress(detalle.latitud, detalle.longitud) || '';

                    // Prioridad: lo que ya ve el usuario en la tabla.
                    let direccionFinal = direccionActual;

                    const isMissing = (val) => {
                        if (!val) return true;
                        const t = String(val).trim().toLowerCase();
                        return t === 'dirección no disponible' || t === 'direccion no disponible' || t === 'no disponible';
                    };

                    if (isMissing(direccionFinal)) {
                        direccionFinal = !isMissing(direccionCache) ? direccionCache : '';
                    }

                    // Último intento (best-effort) solo si sigue faltando y hay coordenadas válidas.
                    if (isMissing(direccionFinal)) {
                        const lat = detalle?.latitud;
                        const lng = detalle?.longitud;
                        if (Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))) {
                            try {
                                const resp = await geocodeService.getReverseGeocodeAsync(lat, lng, { timeoutMs: 12000, concurrency: 8 });
                                if (resp?.formattedAddress) {
                                    direccionFinal = resp.formattedAddress;
                                }
                            } catch (e) {
                                // Ignorar: se mantiene fallback
                            }
                        }
                    }

                    if (isMissing(direccionFinal)) {
                        direccionFinal = 'Dirección no disponible';
                    }

                    subList.push([
                        detalle.tipo_reporte?.toString() || "N/A",
                        detalle.no_economico?.toString() || "N/A",
                        detalle.alias?.toString() || "N/A",
                        detalle.evento?.toString() || "N/A",
                        detalle.fecha_inicio?.toString() || "N/A",
                        detalle.fecha_fin?.toString() || "N/A",
                        detalle.punto_inicio?.toString() || "N/A",
                        detalle.punto_fin?.toString() || "N/A",
                        detalle.latitud?.toString() || "0",
                        detalle.longitud?.toString() || "0",
                        `${detalle.latitud || 0}, ${detalle.longitud || 0}`,
                        (direccionFinal || 'N/A').toString(),
                        detalle.tiempo?.toString() || "N/A",
                    ]);

                }

                //maestro -----------------------------------------------
                let masterData =
                {
                    titulo: `Vehiculo: ${grupo.no_economico}  |  ${grupo.estadiaStr}`,
                    detalles: subList
                }

                //Agrega el maestro a la lista de informacion
                dataReport.push(masterData);

            }


            //Exportar reporte 
            generateExcelReport('Reporte estadias', dataReport, true, columns);

        } catch (error) {

        }
    };

    return (
        <Card className="h-100">

            <Card.Header>

                <Row className='d-flex align-items-center justify-content-end'>
                    <Col md={6}>
                        <h6 className="mb-0 text-nowrap py-2 py-xl-0">{title}</h6>
                    </Col>

                    <Col md={4} className="d-flex justify-content-end align-items-center">

                        <Button
                            variant="primary"
                            size="sm"
                            className="me-2 p-2" onClick={handleExportToExcel}>

                            <img
                                src={iconoPng}
                                alt="Exportar" title='Exportar a Excel'
                                style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} // Ajusta el tamaño
                                className="me-1 ms-1"
                            />

                            {/* <FaFileExport className='me-1 ms-1' /> */}
                        </Button>

                        <InputGroup size="sm" style={{ maxWidth: 200 }}>
                            <Form.Control
                                className='p-2'
                                type="text"
                                placeholder="Buscar..."
                                value={inputValue || ''}
                                onChange={handleSearchChange}
                            />
                            {globalFilter && (
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setGlobalFilter('');
                                        if (onSearch) onSearch('');
                                    }}
                                >
                                    &times;
                                </Button>
                            )}
                        </InputGroup>
                    </Col>

                    <Col md={2}>
                        <Form className='d-flex p-2 justify-content-end'>
                            <Form.Select
                                className='p-2'
                                size="sm"
                                style={{ width: '100px' }}
                                value={table.getState().pagination.pageSize}
                                onChange={e => table.setPageSize(Number(e.target.value))}
                            >
                                <option value="10">10</option>
                                <option value="100">50</option>
                                <option value="100">100</option>
                                <option value="250">250</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                            </Form.Select>
                        </Form>
                    </Col>
                </Row>
            </Card.Header>

            <Card.Body className='mt-0 pt-0 ms-0 me-0 ps-0 pe-0'>
                <GoogleMapsProvider>
                    <div style={{ overflow: 'auto' }}>
                        <table style={{ display: 'flex', flexFlow: 'column', width: '100%' }} className='fs-10 mb-0 mt-0 overflow-hidden table table-striped'>
                            <thead style={{ flex: '0 0 auto' }} className='text-nowrap align-middle'>
                                {table.getHeaderGroups().map(headerGroup => (
                                    <tr key={headerGroup.id} style={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
                                        {headerGroup.headers.map(header => {
                                            return (
                                                <th key={header.id} colSpan={header.colSpan}>
                                                    {header.isPlaceholder ? null : (
                                                        <div>
                                                            {flexRender(
                                                                header.column.columnDef.header,
                                                                header.getContext()
                                                            )}

                                                            {header.column.getCanFilter() ? (
                                                                <div>
                                                                    <Filter column={header.column} table={table} />
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    )}
                                                </th>
                                            )
                                        })}
                                    </tr>
                                ))}
                            </thead>
                            <tbody style={{ flex: '1 1 auto', display: 'block', maxHeight: '400px', overflowY: 'auto' }}>
                                {table.getRowModel().rows.map(row => {

                                    const isMaster = row.original.ismaster != undefined ? row.original.ismaster : false

                                    if (!row.id.includes(".")) {

                                        const cells = row.getVisibleCells()


                                        return (
                                            !row.getCanExpand() ? <></> : <tr key={row.id} className='alert-row d-flex flex-nowrap' style={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
                                                <td width={'70px'}>
                                                    {flexRender(
                                                        cells[0].column.columnDef.cell,
                                                        cells[0].getContext()
                                                    )}
                                                </td>
                                                <td className='fw-bold flex-nowrap text-nowrap flex-grow-0' style={{ ...style1Lines, maxWidth: '350px' }} title={row.original.no_economico}>
                                                    {row.original.no_economico}
                                                </td>
                                                <td className='fw-bold flex-nowrap text-nowrap flex-grow-1' style={{ ...style1Lines }} title={row.original.estadiaStr}>
                                                    {row.original.estadiaStr}
                                                </td>
                                            </tr>
                                        )

                                    } else {

                                        return (
                                            <tr className='alert-row' key={row.id} style={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
                                                {row.getVisibleCells().map(cell => {
                                                    return (
                                                        <td key={cell.id}>
                                                            {flexRender(
                                                                cell.column.columnDef.cell,
                                                                cell.getContext()
                                                            )}
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                        )
                                    }

                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* Modal para ver el mapa */}
                    <Modal
                        show={showMapModal}
                        onHide={() => setShowMapModal(false)}
                        size="lg"
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Evento: {(markers.length > 0 ? markers[0].title : '') || ''}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {infoView}
                            {selectedLocation.lat && selectedLocation.lng ? (
                                <GoogleMapSelector
                                    initialCenter={{
                                        lat: selectedLocation.lat,
                                        lng: selectedLocation.lng,
                                    }}
                                    markers={markers}
                                    geocercas={geocercasFiltradas}
                                    zoomDefault={13}
                                    mapStyle="Default"
                                    className="vh-50"
                                    showStreetView={false}
                                />
                            ) : (
                                <div>
                                    <p>Ubicación no disponible</p>
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>
                </GoogleMapsProvider>
            </Card.Body>

            <Card.Footer className="bg-white">

                <div className='mt-3'>

                    <div className='d-flex align-items-center justify-content-between'>
                        <div className='d-flex align-items-center fs-10'>

                            <span className="me-2">
                                Total: {table.getFilteredRowModel().rows.length} | Página {table.getState().pagination.pageIndex + 1} de {table.getPageCount()}
                            </span>
                            <Form.Control
                                type="number"
                                min="1"
                                max={table.getPageCount()}
                                value={table.getState().pagination.pageIndex + 1}
                                onChange={e => {
                                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                    table.setPageIndex(page);
                                }}
                                style={{ width: '70px', height: '31px' }}
                                size="sm"
                            />
                        </div>

                        <div className='d-flex'>
                            <Button
                                variant="outline-dark"
                                size="sm"
                                className="mx-1"
                                onClick={() => table.setPageIndex(0)}
                                disabled={!table.getCanPreviousPage()}
                            >
                                <FaAngleDoubleLeft />
                                {/* &laquo; Primera */}
                            </Button>

                            <Button
                                variant="outline-dark"
                                size="sm"
                                className="mx-1"
                                onClick={() => table.previousPage()}
                                disabled={!table.getCanPreviousPage()}
                            >
                                <FaAngleLeft />
                                {/* &lt; Anterior */}
                            </Button>

                            {/* Mostrar números de página (5 páginas alrededor de la actual) */}
                            {(() => {
                                // Determinar qué páginas mostrar
                                let pagesArray = [];
                                if (table.getPageCount() <= 5) {
                                    // Si hay 5 o menos páginas, mostrarlas todas
                                    pagesArray = Array.from({ length: table.getPageCount() }, (_, i) => i);
                                } else if (table.getState().pagination.pageIndex <= 2) {
                                    // Si estamos en las primeras páginas
                                    pagesArray = [0, 1, 2, 3, 4];
                                } else if (table.getState().pagination.pageIndex >= table.getPageCount() - 3) {
                                    // Si estamos en las últimas páginas
                                    pagesArray = [
                                        table.getPageCount() - 5,
                                        table.getPageCount() - 4,
                                        table.getPageCount() - 3,
                                        table.getPageCount() - 2,
                                        table.getPageCount() - 1
                                    ];
                                } else {
                                    // Estamos en medio, mostrar 2 antes y 2 después
                                    pagesArray = [
                                        table.getState().pagination.pageIndex - 2,
                                        table.getState().pagination.pageIndex - 1,
                                        table.getState().pagination.pageIndex,
                                        table.getState().pagination.pageIndex + 1,
                                        table.getState().pagination.pageIndex + 2
                                    ];
                                }

                                return pagesArray.map(pageNum => (
                                    <Button
                                        key={`page-${pageNum}`}
                                        variant={pageNum === table.getState().pagination.pageIndex ? "primary" : "outline-dark"}
                                        size="sm"
                                        className="mx-1"
                                        onClick={() => table.setPageIndex(pageNum)}
                                    >
                                        {pageNum + 1}
                                    </Button>
                                ));
                            })()}

                            <Button
                                variant="outline-dark"
                                size="sm"
                                className="mx-1"
                                onClick={() => table.nextPage()}
                                disabled={!table.getCanNextPage()}
                            >
                                {/* Siguiente &gt; */}
                                <FaAngleRight />
                            </Button>

                            <Button
                                variant="outline-dark"
                                size="sm"
                                className="mx-1"
                                onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                                disabled={!table.getCanNextPage()}
                            >
                                {/* Última &raquo; */}
                                <FaAngleDoubleRight />
                            </Button>
                        </div>
                    </div>
                </div>
            </Card.Footer>
        </Card>
    );
};

export default MasterTableEstadias;